import React from "react";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTranslation} from "react-i18next";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {a11yProps, TabPanel} from "../dashboard/VerticalTabs";
import Locations from "./locations";
import Contacts from "./contacts";
import EconomicActivation from "./economic-activation";
import Capital from "./capital";
import Administrators from "./administrators";
// import LegalActs from "./legal-acts";
// import ComplianceConsultation from "./compliance-consultation";
import Shareholders from "./shareholders";
// import PaidValues from "./paid-values";
import {useTaxPayerStorage} from "../../services/storage/TaxPayerStorage";
import {Spinner} from "@material-tailwind/react";
import AdditionalInformation from "./aditional-information";
import LegalComplianceCheck from "./legal-compliance-check";
import CreditData from "./credit-data";
import LegalInformation from "../dashboard/legal-information";

interface VerticalTabsProps {
    setOpenCollapse: React.Dispatch<React.SetStateAction<boolean>>;
    loading: boolean
}

export default function VerticalTabs({setOpenCollapse, loading}: VerticalTabsProps) {
    const person = useTaxPayerStorage(data => data.data)

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const {t} = useTranslation("global")
    const [value, setValue] = React.useState(0);
    const tabsNatural = [
        {id: 0, text: 'credit-data'},
        {id: 1, text: 'establishments'},
        {id: 2, text: 'contacts'},
        {id: 3, text: 'economic-activity'},
        {id: 4, text: 'legal-information'},
    ]

    const tabs = [
        {id: 0, text: 'credit-data'},
        {id: 1, text: 'establishments'},
        {id: 2, text: 'contacts'},
        {id: 3, text: 'economic-activity'},
        {id: 4, text: 'legal-information'},
        {id: 5, text: 'capital'},
        {id: 6, text: 'administrators'},
        {id: 7, text: 'shareholders'},
        {id: 8, text: 'additional-information'},
        {id: 9, text: 'legal-compliance-check'},
        // {id: 6, text: 'compliance-consultation'},
        // {id: 7, text: 'paid-values'},
        // {id: 8, text: 'legal-acts'},
    ]

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        setOpenCollapse(false);
    };

    return (
        <div className={`flex ${isSmallScreen ? 'flex-col' : 'flex-row'} grow bg-white custom-card`}>
            {
                loading ?
                    <div className={'flex flex-row items-center justify-center w-full h-[250px] min-h-full'}>
                        <Spinner className={'h-7 w-7 my-auto'}/>
                    </div>
                    : <>
                        <Tabs
                            className={'w-full sm:w-[20%] sm:min-w-[155px]'}
                            orientation={isSmallScreen ? "horizontal" : "vertical"}
                            variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            sx={{
                                borderRight: !isSmallScreen ? 1 : 0, // No se aplica borde derecho si es pantalla pequeña
                                borderBottom: isSmallScreen ? 1 : 0, // Aplica borde inferior si es pantalla pequeña
                                borderColor: 'divider',
                                '& .MuiTabs-indicator': {
                                    backgroundColor: '#FF4F22', // Color de la línea de selección
                                },
                            }}
                        >
                            {
                                person?.legalEntityType === 'SCD' ?
                                    tabs.map(tab => {
                                        return (
                                            <Tab key={tab.id} label={t(tab.text)} {...a11yProps(tab.id)}
                                                 sx={{
                                                     '&.Mui-selected': {
                                                         color: '#FF4F22', // Color del texto cuando está seleccionado
                                                     },
                                                 }}
                                            />
                                        )
                                    })
                                    : tabsNatural.map(tab => {
                                        return (
                                            <Tab key={tab.id} label={t(tab.text)} {...a11yProps(tab.id)}
                                                 sx={{
                                                     '&.Mui-selected': {
                                                         color: '#FF4F22', // Color del texto cuando está seleccionado
                                                     },
                                                 }}
                                            />
                                        )
                                    })
                            }
                        </Tabs>
                        <TabPanel value={value} index={0}>
                            <CreditData {...{person}}/>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Locations/>
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <Contacts/>
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <EconomicActivation/>
                        </TabPanel>
                        <TabPanel value={value} index={4}>
                            <LegalInformation sri {...{person: person ?? undefined}}/>
                        </TabPanel>
                        <TabPanel value={value} index={5}>
                            <Capital/>
                        </TabPanel>
                        <TabPanel value={value} index={6}>
                            <Administrators/>
                        </TabPanel>
                        <TabPanel value={value} index={7}>
                            <Shareholders/>
                        </TabPanel>
                        <TabPanel value={value} index={8}>
                            <AdditionalInformation/>
                        </TabPanel>
                        <TabPanel value={value} index={9}>
                            <LegalComplianceCheck/>
                        </TabPanel>
                        {/*<TabPanel value={value} index={6}>*/}
                        {/*    <ComplianceConsultation/>*/}
                        {/*</TabPanel>*/}
                        {/*<TabPanel value={value} index={7}>*/}
                        {/*    <PaidValues/>*/}
                        {/*</TabPanel>*/}
                        {/*<TabPanel value={value} index={8}>*/}
                        {/*    <LegalActs/>*/}
                        {/*</TabPanel>*/}
                    </>
            }
        </div>
    );
}
